import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { rootProjects } from 'app/store/root/projects/projects.selectors';
import { updateExtensionProjects } from 'app/store/root/simple-extensions/simple-extensions.actions';
import { simpleExtensions } from 'app/store/root/simple-extensions/simple-extensions.selectors';
import { ProjectOutput, RootSimpleExtensionOutput } from 'core/http/root';
import { selectFirst } from 'core/utils/rx-common';
import {
  UpdateExtensionProjectsDialogComponent,
  UpdateExtensionProjectsDialogData,
  UpdateExtensionProjectsDialogResult,
} from 'root/extensions/update-extension-projects-dialog/update-extension-projects-dialog.component';
import { Subject } from 'rxjs';
import { EagerSource } from 'shared/modules/table/table-utils/table-interfaces';

@Component({
  selector: 'app-simple-extensions',
  templateUrl: './simple-extensions.component.html',
  styleUrls: ['./simple-extensions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SimpleExtensionsComponent implements OnInit {
  private projects = new Array<ProjectOutput>();
  private _reloader = new Subject();

  get reloader(): Subject<unknown> {
    return this._reloader;
  }

  constructor(
    private dialog: MatDialog,
    private store$: Store,
  ) { }

  dataSource: EagerSource<RootSimpleExtensionOutput> = () => this.store$.select(simpleExtensions);

  ngOnInit(): void {
    this.store$.pipe(selectFirst(rootProjects))
      .subscribe(data => this.projects = data);
  }

  openExtensionEditor(extension: RootSimpleExtensionOutput): void {
    const data: UpdateExtensionProjectsDialogData = {
      allProjects: this.projects,
      enabledProjects: extension.projects,
    };

    this.dialog.open(UpdateExtensionProjectsDialogComponent, { data }).afterClosed().subscribe(
      (r: UpdateExtensionProjectsDialogResult | undefined) => {
        if (!r) {
          return;
        }

        this.store$.dispatch(updateExtensionProjects({
          id: extension.id,
          projects: r.enabledProjects.map(c => c.id),
        }));

        this.reloader.next(undefined);
      },
    );
  }
}
